/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_TitleInputs */

const zh_danger_title = /** @type {(inputs: Danger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`危险区域`)
};

const en_danger_title = /** @type {(inputs: Danger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

const es_danger_title = /** @type {(inputs: Danger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de peligro`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Danger_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const danger_title = /** @type {((inputs?: Danger_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_title(inputs)
	if (locale === "en") return en_danger_title(inputs)
	return es_danger_title(inputs)
});